import { simple } from 'src/utils/reducers';

import { clear } from './reducers/clear';
import { update } from './reducers/update';
import { update as updateList } from './reducers/update-list';
import * as query from './reducers/query';
import * as edit from './reducers/edit';
import * as addValue from './reducers/add-value';

// eslint-disable-next-line import/no-default-export
export default simple({
    TAGS_CLEAR: clear,
    TAGS_UPDATE: update,
    TAGS_UPDATE_LIST: updateList,

    TAGS_QUERY_REQUEST: query.request,
    TAGS_QUERY_ERROR: query.error,
    TAGS_QUERY_FINISH: query.finish,

    TAGS_EDIT_REQUEST: edit.request,
    TAGS_EDIT_ERROR: edit.error,
    TAGS_EDIT_FINISH: edit.finish,

    TAGS_ADD_VALUE_REQUEST: addValue.request,
    TAGS_ADD_VALUE_ERROR: addValue.error,
    TAGS_ADD_VALUE_FINISH: addValue.finish,
});
